import PayLinks from "./PayLinks";

export default PayLinks;
